import React, { useMemo, useState } from 'react';

import { useDesktopMediaQuery } from '@/hooks/useMediaQuery';

import Button from '@/components/tangerina/Button';
import Input from '@/components/tangerina/Input';
import Select from '../../Select';
import InputMiles from '../InputMiles';
import Autocomplete, { TOption } from '@/components/global/Autocomplete';

type TFilterOption = {
  title: string;
  card_key: string;
  comparator: string;
  tooltip?: string;
}

interface IProps {
  filters: {
    departure: string;
    arrival: string;
    classtype: string;
    months: string;
    miles: string;
  };
  handleFilterChange: (field: string, value: string) => void;
  handleArrowsClick: () => void;
  isDisabled?: boolean;
  options: {
    departure?: TFilterOption;
    arrival?: TFilterOption;
    classtype?: TFilterOption;
    months?: TFilterOption;
    miles?: TFilterOption;
  };
  departureOptions: TOption[];
  arrivalOptions: TOption[];
  monthsOptions?: TOption[];
}

const months = [
  { value: '01', label: 'Janeiro' },
  { value: '02', label: 'Fevereiro' },
  { value: '03', label: 'Março' },
  { value: '04', label: 'Abril' },
  { value: '05', label: 'Maio' },
  { value: '06', label: 'Junho' },
  { value: '07', label: 'Julho' },
  { value: '08', label: 'Agosto' },
  { value: '09', label: 'Setembro' },
  { value: '10', label: 'Outubro' },
  { value: '11', label: 'Novembro' },
  { value: '12', label: 'Dezembro' },
];

const fligthTypes = [
  { value: 'Nacional', label: 'Nacional' },
  { value: 'Internacional', label: 'Internacional' },
];

export default function FilterContainer({
  filters,
  handleFilterChange,
  handleArrowsClick,
  isDisabled,
  options,
  departureOptions,
  arrivalOptions,
  monthsOptions,
}: IProps) {
  const isDesktop = useDesktopMediaQuery();

  const [departureSelected, setDepartureSelected] = useState<TOption | undefined>(undefined);
  const [arrivalSelected, setArrivalSelected] = useState<TOption | undefined>(undefined);

  const isChangeButtonDisabled = useMemo(() => {
    return isDisabled || (filters.arrival === '' && filters.departure === '')
  }, [isDisabled, filters.arrival, filters.departure]);

  const handleAutocompleteChange = (key: string, option: TOption) => {
    if (key === 'departure') {
      setDepartureSelected(option);
    } else if (key === 'arrival') {
      setArrivalSelected(option);
    }

    handleFilterChange(key, option.value);
  }

  return (
    <div className="vitrine-template8__filters__container">
      <div className="vitrine-template8__filters__container__inputs">
        <div className="vitrine-template8__filters__container__inputs__input vitrine-template8__filters__container__inputs__input--md">
          <Autocomplete
            label={options.departure?.title}
            selected={departureSelected}
            onSelect={(option) => handleAutocompleteChange('departure', option)}
            options={departureOptions}
          />
        </div>
        <div className="vitrine-template8__filters__container__inputs__button-wrap">
          <Button
            appearance="iconContainer"
            icon="compare-arrows"
            size={isDesktop ? 'sm' : 'sm'}
            onClick={handleArrowsClick}
            disabled={isChangeButtonDisabled}
          />
        </div>
        <div className="vitrine-template8__filters__container__inputs__input vitrine-template8__filters__container__inputs__input--md">
          <Autocomplete
            label={options.arrival?.title}
            selected={arrivalSelected}
            onSelect={(option) => handleAutocompleteChange('arrival', option)}
            options={arrivalOptions}
          />
        </div>
      </div>
      <div className="vitrine-template8__filters__container__inputs__input vitrine-template8__filters__container__inputs__input--sm">
        <Select
          label={options.classtype?.title}
          value={filters.classtype}
          onChange={e => handleFilterChange('classtype', e.target.value)}
          options={fligthTypes.map((type) => ({ value: type.value, label: type.label }))}
          disabled={isDisabled}
        />
      </div>
      <div className="vitrine-template8__filters__container__inputs__input vitrine-template8__filters__container__inputs__input--sm">
        <Select
          label={options.months?.title}
          value={filters.months}
          onChange={e => handleFilterChange('months', e.target.value)}
          options={monthsOptions as Array<{ value: string; label: string }>}
          disabled={isDisabled}
        />
      </div>
      <div className="vitrine-template8__filters__container__inputs__input vitrine-template8__filters__container__inputs__input--sm">
        <InputMiles
          label={options.miles?.title}
          placeholder={options.miles?.tooltip}
          disabled={isDisabled}
          filters={filters}
          handleFilterChange={handleFilterChange}
        />
      </div>
    </div>
  );
}
